import React, { useState, useEffect } from "react";
import logo from "../../Assets/Images/logo.png";
import home from "../../Assets/Images/home.png";
import project from "../../Assets/Images/project.png";
import task from "../../Assets/Images/task.png";
import client from "../../Assets/Images/client.png";
import report from "../../Assets/Images/report.png";
import staff from "../../Assets/Images/staff.png";
import setting from "../../Assets/Images/setting.png";
import { Link, NavLink } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useGlobalContext } from "../../Context/GlobalContext";
import { useLocation } from "react-router-dom";
import { FaFilterCircleDollar } from "react-icons/fa6";


const SideBar = ({ toggleSideBar }) => {
  const {
    activeSubmenu,
    setActiveSubmenu,
    selectedSidebarTab,
    setSelectedSidebarTab,
  } = useGlobalContext();

  useEffect(() => {
    console.log(activeSubmenu, selectedSidebarTab);
  }, [activeSubmenu, selectedSidebarTab]);
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [isMenuOpen1, setIsMenuOpen1] = useState(false);
  const toggleMenu1 = () => setIsMenuOpen1(!isMenuOpen1);

  const [isMenuOpen2, setIsMenuOpen2] = useState(false);
  const toggleMenu2 = () => setIsMenuOpen2(!isMenuOpen2);

  const [isMenuOpen3, setIsMenuOpen3] = useState(false);
  const toggleMenu3 = () => setIsMenuOpen3(!isMenuOpen3);

  const [isMenuOpen4, setIsMenuOpen4] = useState(false);
  const toggleMenu4 = () => setIsMenuOpen4(!isMenuOpen4);

  const [isMenuOpen5, setIsMenuOpen5] = useState(false);
  const toggleMenu5 = () => setIsMenuOpen5(!isMenuOpen5);

  const [isMenuOpen6, setIsMenuOpen6] = useState(false);
  const toggleMenu6 = () => setIsMenuOpen6(!isMenuOpen6);

  const [isMenuOpen7, setIsMenuOpen7] = useState(false);
  const toggleMenu7 = () => setIsMenuOpen7(!isMenuOpen7);

  const [isMenuOpen8, setIsMenuOpen8] = useState(false);
  const toggleMenu8 = () => setIsMenuOpen8(!isMenuOpen8);

  const [isMenuOpen9, setIsMenuOpen9] = useState(false);
  const toggleMenu9 = () => setIsMenuOpen9(!isMenuOpen9);

  const [isMenuOpen10, setIsMenuOpen10] = useState(false);
  const toggleMenu10 = () => setIsMenuOpen10(!isMenuOpen9);

  //setup sidebar

  useEffect(() => {
    if (
      location.pathname !== "/settings" &&
      location.pathname !== "/status-main-page"
    ) {
      setIsOpen(false);
    }
  }, [location.pathname]);

  // State to manage sidebar visibility
  const [isOpen, setIsOpen] = useState(false);
  // handle admin sidebar on small screens
  const handleLinkClick = (tab) => {
    // Set the selected sidebar tab
    setSelectedSidebarTab(tab);

    // Close sidebar on small screens
    if (window.innerWidth < 850) {
      // Add the backdrop blur effect when custom-body-class is present
      if (document.body.classList.contains("custom-body-class")) {
        document.body.classList.add("backdrop-blur-sm");
      }

      // Remove the custom class and the blur effect
      document.body.classList.remove("custom-body-class");
      document.body.classList.remove("backdrop-blur-sm");
    }
  };

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  //setup sidebar

  const handleActiveSubmenu = () => {
    if (selectedSidebarTab === "staff") {
      setActiveSubmenu((prev) => !prev);
    } else {
      setActiveSubmenu(false);
    }
  };
  // Handle page selection
  const handlePageClick = (page) => {
    setSelectedPage(page);
    setIsOpen(true); // Keep sidebar open on page selection
    if (window.innerWidth < 850) {
      if (setIsOpen === true) {
        document.body.classList.add("bg-orange-500");
      }
      setIsOpen(false);
      document.body.classList.remove("backdrop-blur-sm");
    }
  };

  const [selectedPage, setSelectedPage] = useState(""); // Track active page

  return (


    <div className="lg:top-[0px] flex-shrink-0 content-container bg-[#27004a] p-[5px] sm:p-[10px] w-full sm:w-[340px] md:w-[270px] h-[100vh] overflow-y-scroll selection sidebar">
      <Link
        to="/"
        className="flex lg:justify-center xl:justify-center p-[20px]"
      >
        <img src={logo} alt="" className="w-[120px]" />
      </Link>
      <ul className="pt-[0px] pr-[2px] pb-[20px] pl-[2px]">
        <li
          onClick={() => {
            handleLinkClick("dashboard");
            handleActiveSubmenu();
          }}
          className={`flex items-center gap-[10px] hover:bg-[#fff] mb-[5px] hover:text-[#8a25b0] p-[10px]   rounded-md  transition-all ${location.pathname === "/" ? "bg-white text-[#8a25b0]" : "text-white"
            } `}
        >
          {/* <img src={home} /> */}
          <HomeIcon />

          <Link to="/" className="">
            Dashboard
          </Link>
        </li>

        <div className="">
          <Link
            to="/projects"
            className={`flex items-center gap-[10px] mb-[5px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/projects"
                ? "bg-white [#8a25b0] text-[#8a25b0]"
                : "text-white"
              }`}
            onClick={() => {
              handleLinkClick("project");
              handleActiveSubmenu();
            }}
          >
            {/* <img src={project} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-folder-kanban"
            >
              <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
              <path d="M8 10v4" />
              <path d="M12 10v2" />
              <path d="M16 10v6" />
            </svg>
            <button onClick={toggleMenu} className=" ">
              Project
            </button>
          </Link>
        </div>

        <div className="">
          <Link
            to="/task"
            onClick={() => {
              handleLinkClick("task");
              handleActiveSubmenu();
            }}
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/task"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={task} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-file-check"
            >
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
              <path d="M14 2v4a2 2 0 0 0 2 2h4" />
              <path d="m9 15 2 2 4-4" />
            </svg>
            <button onClick={toggleMenu1} className=" ">
              Task
            </button>
          </Link>

          <div
            className={`overflow-hidden transition-max-height duration-300 ease-in-out mt-[5px] ${isMenuOpen1 ? "max-h-screen" : "max-h-0"
              }`}
          >
            {/* <Link to="#"
              className="flex items-center gap-[10px] ml-[40px] py-[10px] pl-[0px] rounded-md w-full text-left text-white whitespace-nowrap transition-all"
            >
              <ArrowForwardIosIcon className="arrow-icon-sidebar" />
              Sub Menu
            </Link> */}
          </div>
        </div>

        <div className="">
          <Link
            to="/Clients"
            className={`flex items-center gap-[10px] p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/Clients"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
            onClick={() => {
              handleLinkClick("client");
              handleActiveSubmenu();
            }}
          >
            {/* <img src={client} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-user"
            >
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            <button onClick={toggleMenu2} className=" ">
              Client
            </button>
          </Link>

          <div
            className={`overflow-hidden transition-max-height duration-300 ease-in-out mt-[5px] ${isMenuOpen2 ? "max-h-screen" : "max-h-0"
              }`}
          >
            {/* <Link to="#"
              className="flex items-center gap-[10px] ml-[40px] py-[10px] pl-[0px] rounded-md w-full text-left text-white whitespace-nowrap transition-all"
            >
              <ArrowForwardIosIcon className="arrow-icon-sidebar"/>
              Sub Menu
            </Link> */}
          </div>
        </div>

        <div className="">
          <Link
            to="/report"
            onClick={() => {
              handleLinkClick("report");
            }}
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/report"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={report} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-clipboard-minus"
            >
              <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
              <path d="M9 14h6" />
            </svg>
            <button onClick={toggleMenu3} className=" ">
              Report
            </button>
          </Link>

          <div
            className={`overflow-hidden transition-max-height duration-300 ease-in-out mt-[5px] ${isMenuOpen3 ? "max-h-screen" : "max-h-0"
              }`}
          >
            {/* <Link to="#"
              className="flex items-center gap-[10px] ml-[40px] py-[10px] pl-[0px] rounded-md w-full text-left text-white whitespace-nowrap transition-all"
            >
              <ArrowForwardIosIcon className="arrow-icon-sidebar"/>
              Sub Menu
            </Link> */}
          </div>
        </div>

        <div>
          {/* Main Staff Tab */}
          <div
            className={`flex items-center gap-[10px] px-[10px]  hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/staff-menu"
                ? "bg-white mb-[5px] text-[#8a25b0]"
                : "text-white"
              }`}
          >
            <Link
              to="/staff-menu"
              onClick={() => handleLinkClick("staff")} // Set selected tab
              className="flex gap-3 py-[10px] w-5/6"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              Staff
            </Link>
            <button
              onClick={() => setActiveSubmenu(!activeSubmenu)}
              className={`ml-auto focus:outline-none w-5 h-5 flex items-center justify-center `}
            >
              {activeSubmenu ? (
                <FaChevronDown className="text-sm" />
              ) : (
                <FaChevronRight className="text-sm" />
              )}
            </button>
          </div>

          {/* Submenu */}
          {activeSubmenu && (
            <div className="mt-[5px] transition-all duration-300 overflow-hidden ease-in-out">
              <div>
                <Link
                  to="/payroll-menu"
                  onClick={() => {
                    handleLinkClick("payroll-menu");
                  }}
                  className={`w-full text-left py-[10px] flex items-center gap-[10px] pl-[40px] whitespace-nowrap transition-all rounded-md overflow-hidden ${location.pathname === "/payroll-menu"
                      ? "bg-white text-[#8a25b0]"
                      : "text-white"
                    }`}
                >
                  <FaChevronRight className="arrow-icon-sidebar" />
                  Payroll
                </Link>
              </div>
              <div>
                <Link
                  to="/attendence_summary"
                  onClick={() => {
                    handleLinkClick("attendance");
                  }}
                  className={`w-full text-left py-[10px] flex items-center gap-[10px] pl-[40px] whitespace-nowrap transition-all rounded-md overflow-hidden ${location.pathname === "/attendence_summary"
                      ? "bg-white text-[#8a25b0]"
                      : "text-white"
                    }`}
                >
                  <FaChevronRight className="arrow-icon-sidebar" />
                  Attendance
                </Link>
              </div>
            </div>
          )}
        </div>

        <div className="">
          <Link
            onClick={() => {
              handleLinkClick("role");
              handleActiveSubmenu();
            }}
            to="/role-detail"
            className={`flex items-center gap-[10px] mt-[5px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/role-detail"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={staff} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-user-cog"
            >
              <circle cx="18" cy="15" r="3" />
              <circle cx="9" cy="7" r="4" />
              <path d="M10 15H6a4 4 0 0 0-4 4v2" />
              <path d="m21.7 16.4-.9-.3" />
              <path d="m15.2 13.9-.9-.3" />
              <path d="m16.6 18.7.3-.9" />
              <path d="m19.1 12.2.3-.9" />
              <path d="m19.6 18.7-.4-1" />
              <path d="m16.8 12.3-.4-1" />
              <path d="m14.3 16.6 1-.4" />
              <path d="m20.7 13.8 1-.4" />
            </svg>
            <button onClick={toggleMenu5} className=" ">
              Role
            </button>
          </Link>

          <div
            className={`overflow-hidden transition-max-height duration-300 ease-in-out mt-[5px] ${isMenuOpen5 ? "max-h-screen" : "max-h-0"
              }`}
          >
            {/* 
            <Link to="#"
              className="flex items-center gap-[10px] ml-[40px] py-[10px] pl-[0px] rounded-md w-full text-left text-white whitespace-nowrap transition-all"
            >
              <ArrowForwardIosIcon className="arrow-icon-sidebar"/>
              Sub Menu
            </Link> */}
          </div>
        </div>

        <div className="">
          <Link
            to="/department-details"
            onClick={() => {
              handleLinkClick("department");
              handleActiveSubmenu();
            }}
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/department-details"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={staff} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-git-fork rotate-180"
            >
              <circle cx="12" cy="18" r="3" />
              <circle cx="6" cy="6" r="3" />
              <circle cx="18" cy="6" r="3" />
              <path d="M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" />
              <path d="M12 12v3" />
            </svg>
            <button onClick={toggleMenu6} className=" ">
              Department
            </button>
          </Link>
        </div>

        <div className="">
          <Link
            to="/branch-details"
            onClick={() => {
              handleLinkClick("branch");
              handleActiveSubmenu();
            }}
            className={`flex items-center gap-[10px] mt-[5px] p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/branch-details"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={staff} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-git-fork rotate-180"
            >
              <circle cx="12" cy="18" r="3" />
              <circle cx="6" cy="6" r="3" />
              <circle cx="18" cy="6" r="3" />
              <path d="M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" />
              <path d="M12 12v3" />
            </svg>
            <button onClick={toggleMenu10} className=" ">
              Branch
            </button>
          </Link>
        </div>

        <div className="mt-[5px] mb-[5px]">
          <Link
            onClick={() => {
              handleLinkClick("subscription-plan");
              handleActiveSubmenu();
            }}
            to="/subscription-plan"
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/subscription-plan"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={staff} alt="" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-thumbs-up"
            >
              <path d="M7 10v12" />
              <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
            </svg>
            <button onClick={toggleMenu7} className="whitespace-nowrap">
              Subscriptions Plan
            </button>
          </Link>
        </div>

        <div className="mt-[5px] mb-[5px]">
          <Link
            to="/lead-detail"
            onClick={() => {
              handleLinkClick("department");
              handleActiveSubmenu();
            }}
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/lead-detail"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            {/* <img src={staff} alt="" /> */}
            < FaFilterCircleDollar />  

            <button onClick={toggleMenu6} className=" ">
              Lead
            </button>
          </Link>
        </div>

        {/* <div className="mt-[5px] mb-[5px]">
          <Link
            to="/admin/chats"
            onClick={() => {
              handleLinkClick("department");
              handleActiveSubmenu();
            }}
            className={`flex items-center gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all ${location.pathname === "/chats"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-git-fork rotate-180"
            >
              <circle cx="12" cy="18" r="3" />
              <circle cx="6" cy="6" r="3" />
              <circle cx="18" cy="6" r="3" />
              <path d="M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" />
              <path d="M12 12v3" />
            </svg>
            <button onClick={toggleMenu6} className=" ">
              Chat
            </button>
          </Link>
        </div> */}


        <div className="flex h-auto">
          {/* Toggle button */}
          <button
            onClick={() => {
              toggleSidebar();
              setSelectedSidebarTab("setup");
            }}
            className={`flex items-center w-full gap-[10px]  p-[10px] hover:bg-[#fff] rounded-md hover:text-[#8a25b0] transition-all  ${location.pathname === "/setup"
                ? "bg-white text-[#8a25b0]"
                : "text-white"
              }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-settings"
            >
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            Setup
          </button>

          {/* Sidebar */}
          <div
            className={`fixed  top-[54px] setupsidebar sm:top-[53px]  lg:top-[54px] xl:top-[0px] w-[100%] sm:w-[340px] md:w-[270px]   left-[0] h-[100vh]  text-white z-10 transform ${isOpen ? "translate-x-0" : "-translate-x-[101%]"
              } transition-transform duration-300 ease-in-out`}
          >
            <div className="bg-[#27004a] opacity-100 w-full h-full">
              {/* Close Button bg-[#27004a]*/}
              <div className="flex justify-end items-center px-4 py-2 font-bold text-lg">
                <button onClick={toggleSidebar}>
                  <CloseIcon />
                </button>
              </div>

              {/* Sidebar Links */}
              <ul className="px-4 py-0">
                <Link
                  to="/status-main-page"
                  onClick={() => handlePageClick("status")}
                  className={`p-2  flex items-center gap-[6px]  mb-[10px] rounded-lg cursor-pointer ${location.pathname === "/status-main-page"
                      ? "bg-white text-[purple]"
                      : "hover:bg-white hover:text-[purple]"
                    }`}
                >
                  <HomeIcon className="newsidebar-icon" />
                  Status Manager
                </Link>
                {/* <Link
                  to="/settings"
                  onClick={() => handlePageClick("settings")}
                  className={`p-2  flex items-center  gap-[6px] mb-[10px] rounded-lg cursor-pointer ${location.pathname === "/settings"
                      ? "bg-white text-[purple]"
                      : "hover:bg-white hover:text-[purple]"
                    }`}
                >
                  <SettingsIcon className="newsidebar-icon" />
                  Setting
                </Link> */}
              </ul>
            </div>
          </div>
        </div>
      </ul>
    </div>
  );
};

export default SideBar;
